import { auditMetricScopeOptions } from './constants';
import type { AuditMetricScope } from './types';

interface AuditScopeControlProps {
    value: AuditMetricScope;
    disabled: boolean;
    onChange: (value: AuditMetricScope) => void;
}

const AuditScopeControl = ({ value, disabled, onChange }: AuditScopeControlProps) => (
    <div className="flex flex-col lg:items-end">
        <span className="mb-1 text-xs text-zinc-400">Audit Scope</span>
        <div aria-label="Audit Scope" className="inline-flex rounded-lg bg-zinc-800 p-1" role="group">
            {auditMetricScopeOptions.map((option) => (
                <button
                    aria-pressed={value === option.value}
                    className={`rounded px-3 py-1.5 text-sm font-medium transition-colors ${
                        value === option.value ? 'bg-zinc-700 text-white' : 'text-zinc-400 hover:text-zinc-200'
                    }`}
                    disabled={disabled}
                    key={option.value}
                    type="button"
                    onClick={() => onChange(option.value)}
                >
                    {option.label}
                </button>
            ))}
        </div>
    </div>
);

export default AuditScopeControl;
